import React from 'react';
import { GenericDeleteModal } from 'components';
import { VoidFn } from 'types/baseTypes';

interface DeleteNoteConfirmationModalProps {
  onCloseClick: VoidFn;
  handleDelete: VoidFn;
  processingDelete: boolean;
}

export const DeleteNoteConfirmationModal: React.FC<DeleteNoteConfirmationModalProps> = ({
  onCloseClick,
  handleDelete,
  processingDelete
}) => {
  return (
    <GenericDeleteModal
      onPrimaryBtnClick={handleDelete}
      onSecondaryBtnClick={onCloseClick}
      isActionInProgress={processingDelete}
      primaryBtnId="delete-note-confirm"
      primaryBtnLabel="Yes"
      primaryBtnStyle="path-stroke-current"
      secondaryBtnId="delete-note-cancel"
      secondaryBtnLabel="Cancel"
      showModal={true}
      title="Delete note"
      subTitle="Are you sure you want to delete note from job?"
    />
  );
};
